import { AfterViewInit, Component } from '@angular/core';
@Component({
  template:
    '<div id="jaas-container" style="width: 1000px; height: 700px; margin: 0 auto; padding: 1rem;"></div>',
})
export class VideoCallManagerComponent implements AfterViewInit {
  private api;
  private TOOLBAR_BUTTONS: [
    'microphone',
    'camera',
    'fullscreen',
    'fodeviceselection',
    'hangup',
    'profile',
    'chat',
    'recording',
    'settings',
    'videoquality',
    'filmstrip',
    'invite',
    'stats',
    'shortcuts',
    'tileview',
    'videobackgroundblur',
    'mute-everyone',
    'security'
  ];

  constructor() {}

  ngAfterViewInit() {
    const api = new JitsiIframeAPI('8x8.vc', {
      roomName: 'vpaas-magic-cookie-60959015a0da42cd8bfd05877177df40/roomA',
      parentNode: document.getElementById('jaas-container'),
      jwt:
        'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6InZwYWFzLW1hZ2ljLWNvb2tpZS02MDk1OTAxNWEwZGE0MmNkOGJmZDA1ODc3MTc3ZGY0MC80YTIwNDkifQ.eyJhdWQiOiJqaXRzaSIsImlzcyI6ImNoYXQiLCJzdWIiOiJ2cGFhcy1tYWdpYy1jb29raWUtNjA5NTkwMTVhMGRhNDJjZDhiZmQwNTg3NzE3N2RmNDAiLCJyb29tIjoicm9vbUEiLCJjb250ZXh0Ijp7ImZlYXR1cmVzIjp7ImxpdmVzdHJlYW1pbmciOmZhbHNlLCJvdXRib3VuZC1jYWxsIjpmYWxzZSwidHJhbnNjcmlwdGlvbiI6ZmFsc2UsInJlY29yZGluZyI6dHJ1ZX0sInVzZXIiOnsibmFtZSI6IkFjY291bnQgbWFuYWdlciIsIm1vZGVyYXRvciI6dHJ1ZSwiYXZhdGFyIjoiIn19LCJpYXQiOjE2MTA5NTc4OTh9.CgKJlgA05nOTRMRfoxrWhciz_OwNZIYd7AcdA--R1xVSBrP2MkMqyi2OjpjD5-WmGlW5sEJ0omoPpqw16mldGBRiYIUOIDNy9evjAhhjz9I1L3X98DmS7uRm2pvurWeAvYwfTVpLZMgX8TyGkdzJZ3qtm-_TSZMtbzpn5zqjbf11KQQoEjMAGDyIvHGzkj-m9Q-c15gMEIjbCneUUprPA94U_B2YsrWtxMrAhObXwQCfFEXQZZKeuQlP8NjKXUPohWc4cf1ZfcCwuUCgRLJ9xcf-BFssL7ggU435WeFS2_AbYfsv21jwVhl0h3oqH0U8MFT3pTRgh7CVs6gHY8KfvONe6OOYgxmbYul3isAb-yKNaFahituTzPv0xUzau0bjBtdq_IoXBnKZh9Hq1gsc84pAqqwen1QVkeoR3ItTUWM93BbpEaPp3qdySzkY4uXGwx93eY3Iiw_OlMMJB0fL8N8i-x5Cg8-HF6pkVevAYHBRAWAAPM0vyXT1VSZi2h_IHWww9rPVUIv_MHDbDsX5H85XdtIkSrFXxa13hbhOooSc0-LnxCcywk1V9gq7Lq-A4ZVBsdjCQ0eVkdZzm9OTU1z4SzQcCRg318pKu-acdl3Snw-TjuJ0dousp1bW0zPHoDsEPST8CY9yn79B1UJeseRTN_cKMpXAlVteMqy0aFk',
      interfaceConfigOverwrite: {
        TOOLBAR_BUTTONS: this.TOOLBAR_BUTTONS,
        MOBILE_APP_PROMO: false,
        SHOW_CHROME_EXTENSION_BANNER: false,
        HIDE_INVITE_MORE_HEADER: true,
      },
      configOverwrite: {
        disableProfile: true,
        enableWelcomePage: false,
        noticeMessage: 'notice message',
        disableInviteFunctions: true,
        disableTileView: false,
      },
    });

    api.addListener('participantJoined', () => {
      api.executeCommand('toggleTileView');
    });
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-login/video-call/video-call-manager.component.ts